<template>
    <section>
        <attendee-stats :users="acceptedUsers"></attendee-stats>
        <ul class="divide-y divide-gray-200 overflow-y-auto">
            <li
                class="px-6 py-5 relative"
                v-for="(user, index) in acceptedUsers"
                v-bind:key="index"
            >
                <div
                    class="group flex justify-between items-center space-x-2"
                    v-if="!user.tts"
                >
                    <a class="-m-1 p-1 block">
                        <span
                            class="absolute inset-0 group-hover:bg-gray-50"
                        ></span>
                        <div class="flex-1 flex items-center min-w-0 relative">
                            <span class="flex-shrink-0 inline-block relative">
                                <img
                                    class="h-10 w-10 rounded-full"
                                    :src="user.avatar"
                                    alt
                                />
                                <span
                                    class="absolute top-0 right-0 block h-2.5 w-2.5 rounded-full text-white shadow-solid bg-green-400"
                                ></span>
                            </span>
                            <div class="ml-4 truncate">
                                <div
                                    class="text-sm leading-5 font-medium text-gray-900 truncate"
                                >
                                    {{ user.name }}
                                </div>

                                <span
                                    class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-indigo-100 text-indigo-800 mr-2"
                                    v-if="user.voting_weight && showWeight > 0"
                                >
                                    {{
                                        t(
                                            "attendees.sidebar.voting_weight",
                                            "stemgewicht:"
                                        )
                                    }}
                                    {{ user.voting_weight }}
                                </span>

                                <span
                                    class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                                    v-if="user.is_moderator"
                                >
                                    moderator
                                </span>
                                <span
                                    class="px-2 inline-flex text-xs mr-2 leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800"
                                    v-if="
                                        !user.is_moderator && user.can_publish
                                    "
                                >
                                    {{
                                        t(
                                            "attendees.sidebar.can_publish",
                                            "kan uitzenden"
                                        )
                                    }}
                                </span>
                            </div>
                        </div>
                    </a>
                </div>
            </li>
        </ul>
    </section>
</template>

<script>
// import { ArrowSmDownIcon, ArrowSmUpIcon } from "@heroicons/vue/solid";
// import {
//     CursorClickIcon,
//     MailOpenIcon,
//     UsersIcon,
// } from "@heroicons/vue/outline";

// const stats = [
//     {
//         id: 1,
//         name: "Total Subscribers",
//         stat: "71,897",
//         icon: UsersIcon,
//         change: "122",
//         changeType: "increase",
//     },
// ];

export default {
    mounted() {
        let self = this;
        setTimeout(function () {
            self.isOn = true;
        }, 2000);

        try {
            this.showWeight = parseInt(
                document.head.querySelector('meta[name="users_weight"]').content
            );
        } catch (error) {}
    },
    components: {
        // ArrowSmDownIcon,
        // ArrowSmUpIcon,
    },
    props: ["users"],
    data() {
        return {
            isOn: false,
            showWeight: 0,
        };
    },
    methods: {},
    computed: {
        acceptedUsers() {
            var self = this;
            try {
                if (this.users) {
                    return this.users.filter(function (u) {
                        return !u.tts;
                    });
                }
            } catch (error) {}
            return this.users;
        },
    },
};
</script>
